var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51 8.312c.016-.624.24-.976.832-1.44.56-.464 1.056-.928 1.472-1.392.432-.48.64-1.072.64-1.76 0-.8-.272-1.504-.816-2.096C6.094 1.032 5.23.728 4.062.728c-1.072 0-1.92.304-2.56.928-.64.624-.96 1.44-.96 2.464 0 .304.032.624.096.944l1.376.064a3.559 3.559 0 01-.112-.912c0-1.472.768-2.352 2.16-2.352 1.296 0 1.952.848 1.952 1.888 0 .592-.176 1.056-.512 1.392-.336.336-.704.656-1.072.96-.848.688-1.168 1.296-1.168 2.208H4.51zM3.038 11h1.6V9.4h-1.6V11z",
    fill: "#C5DF9E"
  })));
}
export default SvgQuestionMark;